export default {
    name: 'Ailes de givre',
    boostOneShot: {
        lv1: 1,
        lv2: 2,
        lv3: 4,
        lv4: NaN,
        lv5: NaN
    },
    oneShot: {
        lv1: 1,
        lv2: 3,
        lv3: 10,
        lv4: NaN,
        lv5: NaN
    },
    boostOneByOne: {
        lv1: NaN,
        lv2: NaN,
        lv3: NaN,
        lv4: NaN,
        lv5: NaN
    },
    oneByOne: {
        lv1: NaN,
        lv2: NaN,
        lv3: NaN,
        lv4: NaN,
        lv5: NaN
    }
};
